import React from "react";
import { useCountdown } from "../hooks/useCountdown";

interface CountdownTimerProps {
  className?: string;
}

export function CountdownTimer({ className = "" }: CountdownTimerProps) {
  const { formattedTime } = useCountdown();

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2 py-1 bg-primary/10 rounded-md text-primary ${className}`}
      aria-live="off"
    >
      <time className="font-medium text-sm leading-none tabular-nums">
        {formattedTime}
      </time>
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M9.9987 8.16666V11L11.832 12.8333M16.1654 11C16.1654 14.4057 13.4044 17.1667 9.9987 17.1667C6.59294 17.1667 3.83203 14.4057 3.83203 11C3.83203 7.59424 6.59294 4.83333 9.9987 4.83333C13.4044 4.83333 16.1654 7.59424 16.1654 11Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}
